import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PublicComponent } from './public.component';
import { PublicRoutingModule } from './public-routing.module';
import { PublicHomeComponent } from './public-home/public-home.component';
import { LoginComponent } from './login/login.component';
import { FormsModule } from '@angular/forms';
import { AppContextService } from '../services/app-context.service';
import { TranslateModule } from '../services/translate/translate.module';
import { CoreModule } from '../core/core.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ConfirmingSupplierInvitationResponseComponent } from './invitations/confirming/supplier-invitation-response/supplier-confirming-invitation-response.component';
import { ConfirmingBuyerInvitationResponseComponent } from './invitations/confirming/buyer-invitation-response/buyer-invitation-response.component';
import { UserInvitationResponseComponent } from './invitations/user-invitation-response/user-invitation-response.component';
import { FactoringSupplierInvitationResponseComponent } from './invitations/factoring/supplier-invitation-response/supplier-invitation-response.component';
import { ResetLoggedInformationComponent } from './reset-logged-information/reset-logged-information.component';
import { MfaSelectComponent } from '../public/mfa/mfa-select/mfa-select.component';
import { MfaVerifyComponent } from '../public/mfa/mfa-verify/mfa-verify.component';
import { MfaSetUpOtpPageComponent } from '../public/mfa/mfa-setup-otp-page/mfa-setup-otp-page.component';
import { InvitationScreenComponent } from '../shared-components/invitation-screen/invitation-screen.component';

@NgModule({
	imports: [CommonModule, FormsModule, CoreModule, PublicRoutingModule, TranslateModule, ReactiveFormsModule],
	providers: [AppContextService],
	declarations: [
		PublicComponent,
		PublicHomeComponent,
		LoginComponent,
		ResetPasswordComponent,
		UserInvitationResponseComponent,
		ConfirmingSupplierInvitationResponseComponent,
		ConfirmingBuyerInvitationResponseComponent,
		FactoringSupplierInvitationResponseComponent,
		InvitationScreenComponent,
		ResetLoggedInformationComponent,
		MfaSelectComponent,
		MfaVerifyComponent,
		MfaSetUpOtpPageComponent,
	],
})
export class PublicModule {}
